module.exports = __webpack_public_path__ + "img/Frutos Mumificados com Esporodóquios e Peritécios 9.58e500d9.webp";